module.exports = " <div v-if=isReady class=message_view v-el:view=\"\" _v-e345557e=\"\"> <message v-for=\"message of messageList\" :session-type=type :message=message _v-e345557e=\"\"></message> </div> <div v-else=\"\" class=message_view _v-e345557e=\"\"></div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-e345557e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/body/session/MessageView.vue
 ** module id = 367
 ** module chunks = 2
 **/